import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Dialog } from '@root/shared/ui-kit'

import { TradeSettingsPresetForm } from './trade-settings-preset-form'

import type { TradeSettingsFormProps } from './trade-settings-preset-form'
import type { DialogControlProps } from '@root/shared/ui-kit'

type Props = DialogControlProps & TradeSettingsFormProps
export const TradeSettingsModal: React.FC<Props> = ({
  open,
  onOpenChange,
  ...formProps
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('trade_settings.preset-settings')}
    >
      <Dialog.Header title={t('trade_settings.preset-settings')} />
      <TradeSettingsPresetForm
        {...formProps}
        onSaved={(settings) => {
          formProps.onSaved?.(settings)
          onOpenChange?.(false)
        }}
      />
    </Root>
  )
}

const Root = styled(Dialog)`
  width: 360px;
  max-height: 90vh;
`
